import Autosuggest from 'react-autosuggest'
import FontAwesome from 'react-fontawesome'
import { InputGroup, Glyphicon } from 'react-bootstrap'
import styled from 'styled-components'
import Input from '../Subheader/Input'

const renderInput = (inputProps, clearHandler, isFetching) => {
  let input

  const focus = () => {
    input && input.focus()
  }

  return (
    <InputGroup>
      <Input {...inputProps} inputRef={(e) => (input = e)} />
      <InputGroup.Addon
        onClick={inputProps.value !== '' ? clearHandler : focus}
      >
        {isFetching && <FontAwesome name="spinner" spin />}

        {!isFetching && (
          <Glyphicon
            glyph={inputProps.value === '' ? 'search' : 'remove-circle'}
          />
        )}
      </InputGroup.Addon>
    </InputGroup>
  )
}

const SuggestContainer = styled.div`
  @media only screen and (max-width: 768px) {
    position: relative;
    z-index: 700;
  }
`

const SuggestionItem = styled.div`
  padding: 8px;
  border-bottom: 1px solid var(--light-gray);
  font-size: 14px;
`
const renderSuggestion = (item) => <SuggestionItem>{item}</SuggestionItem>

const Suggest = ({ autosuggestProps, clearHandler, isFetching }) => (
  <SuggestContainer className="autosuggest-no-scroll">
    <Autosuggest
      {...autosuggestProps}
      renderSuggestion={renderSuggestion}
      renderInputComponent={(inputProps) =>
        renderInput(inputProps, clearHandler, isFetching)
      }
      focusInputOnSuggestionClick={false}
      shouldRenderSuggestions={(val) => val.trim().length > 1}
      id="essearch-autocomplete"
    />
  </SuggestContainer>
)

export default Suggest
